import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable( {
  providedIn: 'root',
} )
export class SasTokenService {
  private http = inject(HttpClient);

  private storageUrl = `${environment.apiUrl}/storage`;


  constructor() {
  }

  getSasToken( userId: string, fileName: string ): Observable<string> {
    const sasTokenUrl = `${this.storageUrl}/sas-token/${userId}/${fileName}`;
    return this.http.get<string>( sasTokenUrl, { responseType: 'text' as 'json' } );
  }

  getSasTokenForCompany( companyId: string, fileName: string ): Observable<string> {
    const sasTokenUrl = `${this.storageUrl}/sas-token/company/${companyId}/${fileName}`;
    return this.http.get<string>( sasTokenUrl, { responseType: 'text' as 'json' } );
  }
}
